import { gql } from '@apollo/client';

export const serviceLevelCompatibilityFragments = {
  serviceLevelCompatibilityItem: gql`
    fragment ServiceLevelCompatibilityItem on ServiceLevelCompatibility {
      id
      description
      engineeringStatus
      updatedBy
      updatedTime
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedTime
      preparedBy
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedTime
      checkedBy
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedTime
      approvedBy
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      serviceLevelCable {
        name
      }
      serviceLevelRaceway {
        name
      }
    }
  `,
};

export const GET_SERVICE_LEVEL_COMPATIBILITY_BY_ID = gql`
  ${serviceLevelCompatibilityFragments.serviceLevelCompatibilityItem}
  query ServiceLevelCompatibilityById($id: ID!) {
    serviceLevelCompatibilityById(id: $id) {
      ...ServiceLevelCompatibilityItem
    }
  }
`;

export const SEARCH_SERVICE_LEVEL_COMPATIBILITIES = gql`
  ${serviceLevelCompatibilityFragments.serviceLevelCompatibilityItem}
  query SearchServiceLevelCompatibilities($searchInput: SearchInput) {
    searchServiceLevelCompatibilities(searchInput: $searchInput) {
      items {
        ...ServiceLevelCompatibilityItem
      }
    }
  }
`;

export const SAVE_SERVICE_LEVEL_COMPATIBILITIES = gql`
  ${serviceLevelCompatibilityFragments.serviceLevelCompatibilityItem}
  mutation SaveServiceLevelCompatibility($serviceLevelCompInput: [ServiceLevelCompInput!]!) {
    saveServiceLevelCompatibility(serviceLevelCompInput: $serviceLevelCompInput) {
      serviceLevelCompatibilities {
        ...ServiceLevelCompatibilityItem
      }
      errors
      infos
    }
  }
`;

export const ISSUE_SERVICE_LEVEL_COMPATIBILITIES = gql`
  ${serviceLevelCompatibilityFragments.serviceLevelCompatibilityItem}
  mutation IssueServiceLevelCompatibilities(
    $issueServiceLevelCompatibilityInput: IssueServiceLevelCompatibilityInput!
  ) {
    issueServiceLevelCompatibilities(issueServiceLevelCompatibilityInput: $issueServiceLevelCompatibilityInput) {
      serviceLevelCompatibilities {
        ...ServiceLevelCompatibilityItem
      }
      errors {
        messageKeys
      }
    }
  }
`;

export const VALIDATE_SERVICE_LEVEL_COMPATIBILITY = gql`
  query ValidateServiceLevelCompatibility(
    $validateServiceLevelCompatibilityInput: ValidateServiceLevelCompatibilityInput!
  ) {
    validateServiceLevelCompatibility(validateServiceLevelCompatibilityInput: $validateServiceLevelCompatibilityInput) {
      isCompatible
      infos
    }
  }
`;
